import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationInfusionActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-infusion-slot-v2',
    templateUrl: './medication-infusion-slot-v2.component.html',
    styleUrl: './medication-infusion-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationInfusionSlotComponentV2 implements SheetSlotComponentBase {

	action!: MedicationInfusionActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationInfusionActionV2 | null) {
		this.action = action as MedicationInfusionActionV2;
		this.value = this.action.rate?.value?.toString() ?? null;
	}

	constructor() {
	}
}